"use client";
import {
  __async
} from "../chunk-M66XENHI.js";
import { UAParser } from "ua-parser-js";
const isPasskeySupported = (userAgent) => __async(void 0, null, function* () {
  var _a, _b, _c;
  const directPasskeyCheck = yield (_b = (_a = window == null ? void 0 : window.PublicKeyCredential) == null ? void 0 : _a.isUserVerifyingPlatformAuthenticatorAvailable) == null ? void 0 : _b.call(_a);
  if (directPasskeyCheck === true || directPasskeyCheck === false) {
    return directPasskeyCheck;
  }
  const osName = (_c = new UAParser(userAgent).getOS().name) == null ? void 0 : _c.toLowerCase();
  return !!osName && !["linux", "chrome os"].includes(osName);
});
export {
  isPasskeySupported
};
